import React from "react";

import { Card, Icon } from "components";

export const CTACard = ({
  AlertHeader,
  children,
  ctaIcon,
  ctaText,
  disabled,
  InfoHeader,
  NormalHeader,
  showCTA,
  WarningHeader,
  SuccessHeader,
  onCtaClick,
  className,
}) => (
  <Card className={`cta-card ${className}`}>
    {SuccessHeader && <div className="extra-header success-header">{SuccessHeader}</div>}
    {AlertHeader && <div className="extra-header alert-header">{AlertHeader}</div>}
    {WarningHeader && <div className="extra-header warning-header">{WarningHeader}</div>}
    {InfoHeader && <div className="extra-header info-header">{InfoHeader}</div>}
    {NormalHeader && <div className="extra-header">{NormalHeader}</div>}
    <div className="content">{children}</div>
    {showCTA && (
      <>
        <div className={`cta ${disabled ? "disabled" : ""}`} onClick={onCtaClick}>
          <div>
            <Icon iconName={ctaIcon} />
            <span>{ctaText}</span>
          </div>
          <Icon iconName="tabler/arrow-right" />
        </div>
      </>
    )}
  </Card>
);
